import moment from 'moment';
import { getSharedConfig } from '../helpers/configs';

export function getCacheExpiration(expirationMinutesCustom?: number): string {
  const sharedConf = getSharedConfig();
  const expirationMinutes = expirationMinutesCustom ?? sharedConf.cacheDurationMinutes;
  const expiration = moment.utc().add(expirationMinutes, 'minutes');
  return expiration.toISOString();
}
